import { BaseResponseDto } from "types/api/baseResponseDto";

import { makeCancellableAPIRequest } from "./index";

const RegexAPI = {
  validateRegex(regex: string) {
    return makeCancellableAPIRequest<BaseResponseDto<string>>(
      "GET",
      `/api/regex/validate`,
      {
        params: { regex: encodeURIComponent(regex) },
      },
    );
  },
};

export default RegexAPI;
